import React from "react";
import { EditOutlined } from "@ant-design/icons";
import { List, Space, Tag } from "antd";
import { Link } from "react-router-dom";

const Item = ({ is_active, worker }) => (
  <List.Item style={{ padding: "12px 24px" }}>
    <Space>
      <Tag color={is_active ? "green" : "red"}>
        {is_active ? "Aktywny" : "Zablokowany"}
      </Tag>
      <Link to={`/workers/${worker?.id}`}>
        {worker?.full_name} <EditOutlined />
      </Link>
    </Space>
  </List.Item>
);

export default Item;
